import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OptionInterface } from '../../../../core/models/option.interface';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-autocomplete-field',
  templateUrl: './autocomplete-field.component.html',
  styleUrls: ['./autocomplete-field.component.css']
})
export class AutocompleteFieldComponent {
  @Input() id: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() options: OptionInterface[];
  @Input() class = 'field';
  @Input() allowClear = false;
  @Input() notFoundText = 'shared.autocomplete.notFound';
  @Input() placeholder: string;
  @Input() hideLabel = false;
  @Input() hideErrors = false;
  @Output() search = new EventEmitter<string>();
  @Output() change = new EventEmitter<any>();
  @Output() clear = new EventEmitter<void>();
  @ViewChild('error') error;
  @ViewChild('selectField') selectField: NgSelectComponent;

  setFocus = () => {
    setTimeout(() => {
      this.selectField.focusSearchInput();
    }, 10);

  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/autocomplete-field/autocomplete-field.component.ts